<script>
import { Swiper, Pagination } from 'swiper'
import PopupMan from '@/components/Popup/PopupMan.vue'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'

export default {
  name: 'MySwiperComponent',
  emit: ['update-index'],
  components: {
    PopupMan,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    tag: {
      type: String,
      default: '',
    },
  },
  beforeDestroy() {
    this.destroySwiper() // 組件銷毀時移除 Swiper
  },
  mounted() {
    if (this.data.length >= 1) {
      this.$nextTick(() => {
        this.updateFilterData()
        this.adjustSlideHeight()
      })
    }
  },
  data: () => ({
    isMan: false,
    currentSelect: 0,
    filterData: [],
    swiper: null,
  }),
  watch: {
    data: {
      deep: true,
      handler() {
        this.updateFilterData()
      },
    },
    tag() {
      this.updateFilterData()
    },
  },
  methods: {
    adjustSlideHeight() {
      this.$nextTick(() => {
        // 獲取所有 Swiper 幻燈片
        const slides = document.querySelectorAll('#manSwiper .swiper-slide')
        if (slides.length === 0) return

        // 計算最高的高度
        let maxHeight = 0
        slides.forEach(slide => {
          const slideHeight = slide.scrollHeight
          if (slideHeight > maxHeight) {
            maxHeight = slideHeight
          }
        })

        // 設定所有 Swiper 幻燈片為最大高度
        slides.forEach(slide => {
          slide.style.height = `${maxHeight}px`
        })
      })
    },
    updateFilterData() {
      const filtered = this.data.filter(item => item.category === this.tag)
      this.filterData = filtered.length > 0 ? filtered : this.data

      if (this.filterData.length >= 1) {
        this.$nextTick(() => {
          this.initSwiper()
        })
      } else {
        this.destroySwiper()
      }
    },
    checkScrollbar(index = 1) {
      this.$nextTick(() => {
        const pagination = document.querySelector('.swiper-pagination.manPagination')
        if (!pagination) return

        const totalSlides = this.filterData.length
        const leftBoundary = 8 // 左邊界數量
        const rightBoundary = 8 // 右邊界數量

        // 左邊界：index 0-7
        if (index < leftBoundary) {
          pagination.scrollTo({
            left: 0,
            behavior: 'smooth',
          })
          return
        }

        // 右邊界：index >= (total - 8)
        if (index >= totalSlides - rightBoundary) {
          const paginationWidth = pagination.clientWidth
          const maxScroll = Math.max(0, pagination.scrollWidth - paginationWidth)
          pagination.scrollTo({
            left: maxScroll,
            behavior: 'smooth',
          })
          return
        }

        // 中間區域：動態滑動
        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet')
        const targetBullet = bullets[index]

        if (!targetBullet) return

        // 獲取目標 bullet 的位置
        const bulletLeft = targetBullet.offsetLeft
        const bulletWidth = targetBullet.offsetWidth
        const paginationWidth = pagination.clientWidth

        // 讓目標 bullet 居中
        const centerPosition = bulletLeft + bulletWidth / 2 - paginationWidth / 2

        // 限制滾動範圍
        const maxScroll = pagination.scrollWidth - paginationWidth
        const finalScrollPosition = Math.max(0, Math.min(centerPosition, maxScroll))

        console.log(`Index: ${index}/${totalSlides}, 滾動到: ${finalScrollPosition}`)

        pagination.scrollTo({
          left: finalScrollPosition,
          behavior: 'smooth',
        })
      })
    },
    getValue(v) {
      this.isMan = v
    },
    handleClick(index) {
      this.isMan = true
      this.currentSelect = index
    },
    initSwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true) // 先銷毀已存在的 Swiper
      }
      this.swiper = new Swiper('.swiper-container', {
        slidesPerView: 2,
        spaceBetween: 24,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        modules: [Pagination],
        on: {
          init: this.adjustSlideHeight,
          slideChange: el => {
            this.$emit('update-index', el.realIndex)
            this.checkScrollbar(el.realIndex)
          },
        },
      })
    },
    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true)
        this.swiper = null
      }
    },
  },
}
</script>
<template>
  <div id="manSwiper" v-if="data.length >= 1" class="swiper-container">
    <PopupMan v-if="isMan" @update:modelValue="getValue" :data="filterData[currentSelect]" />
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(info, index) in filterData"
        :key="info.id"
        @click="handleClick(index)"
      >
        <div class="content">
          <div
            v-show="info.type"
            :class="{
              icon: info.type === '促銷' || info.type === '熱門',
              cheap: info.type === '促銷',
              hot: info.type === '熱門',
            }"
            class="sell"
          >
            <img
              v-if="info.type === '促銷'"
              src="@/assets/images/hotsell.svg"
              style="width: 16px; height: 16px"
              alt=""
            />
            <img
              v-else-if="info.type === '熱門'"
              src="@/assets/images/cheapsell.svg"
              style="width: 16px; height: 16px"
              alt=""
            />
            {{ info.type }}
          </div>
          <img class="dog_card" style="margin-bottom: 12px" :src="info.imgSrc" />
          <div class="titlegg" style="font-size: 14px">{{ info.title }}</div>
          <div class="price" style="margin-top: 12px">
            <p class="normal" v-show="info.promotion">${{ info.price }}</p>
            <p class="cut">${{ info.promotion || info.price }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination manPagination"></div>
  </div>
</template>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  padding: 20px 0px 44px;
  // aspect-ratio: 375/296;
  position: relative; /* 分頁指示器需要相對定位 */
}
.swiper-slide {
  flex-shrink: 0;
  width: auto; /* 自動由 Swiper 控制寬度 */
  height: 100%;
  text-align: center;
  border-radius: 10px;
  // aspect-ratio: 160/245;
  background-color: #fff;
  box-shadow: -1px 2px 10px -2px #4b251833, 1px 1px 4px -2px #4b25182d;
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 12px 8px;
  box-sizing: border-box;
  text-align: start;
  & .sell {
    position: absolute;
    top: 8px;
    left: -8px;
    display: flex;
    align-items: center;
    background-color: #ff7649;
    color: white;
    border-radius: 4px;
    width: fit-content;
    font-size: 10px;
    line-height: 1.2;
    padding: 3px 8px 3px 8px;
    min-height: 22px;;
    &.icon {
      padding: 3px 6px 3px 3px !important;
    }
    &.cheap {
      background-color: #ff453a !important;
    }
    &.hot {
      background-color: #ffc300 !important;
    }
  }
}
.titlegg {
  font-family: Noto Sans TC;
  color: #0d0c0c;
  font-weight: 400 !important;
  line-height: 16.8px !important;
  letter-spacing: 0.56px !important;
  min-height: 44px !important;
  // display:-webkit-box;
  // -webkit-box-orient:vertical;
  // -webkit-line-clamp:2;
  // word-break: break-word;
  // overflow:hidden;
}
.price {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 4px;
  & .normal {
    font-size: 12px;
    line-height: 14.4px;
    text-decoration: line-through;
    color: #ccc;
  }
  & .cut {
    font-weight: bold;
    font-size: 16px;
    line-height: 19.2px;
    color: #ff7649;
  }
}
.info_time {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-weight: bold;
  font-size: 12px;
  line-height: 12.4px;
  letter-spacing: 4%;
  color: white;
}
.info_container {
  position: relative;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 14px;
  padding: 12px 21px;
}
.dog_card {
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 8px;
  overflow: hidden;
}
.info_content {
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 12px;
  font-weight: normal;
  line-height: 16.8px;
  letter-spacing: 4%;
  font-size: 14px;
  color: #0d0c0c;
}
.info_point {
  display: flex;
  align-items: center;
  gap: 3.5px;
}
.info_point img {
  width: 100%;
  height: 100%;
}
:deep(.swiper-pagination) {
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  position: absolute;
  overflow: scroll;
  bottom: 14px;
  left: 0;
  right: 0;
  text-align: center;
  width: fit-content;
  max-width: 124px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

:deep(.swiper-pagination-bullet) {
  background-color: #909090;
  flex-shrink: 0;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  transition: 0.3s;
}

:deep(.swiper-pagination-bullet-active) {
  width: 12px;
  border-radius: 10px;
  background-color: #ff7649;
}
</style>
